import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import './ModernTextField.css';

const ModernTextField = ({ 
  value, 
  onChange, 
  label, 
  icon: Icon, 
  type = 'text', 
  readOnly = false,
  maxLength
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && !showPassword ? 'password' : type === 'password' ? 'text' : type;

  return (
    <div className="modern-input-wrapper">
      <div className="modern-input-container">
        {Icon && <Icon className="input-icon" size={20} />}
        
        <div className="input-floating-label">
          <input
            type={inputType}
            value={value}
            onChange={(e) => {
              if (maxLength && e.target.value.length > maxLength) return;
              onChange(e.target.value);
            }}
            placeholder=" " /* Required for floating label CSS trick */
            readOnly={readOnly}
            className="modern-input"
          />
          <label>{label}</label>
        </div>

        {isPassword && (
          <button 
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
            tabIndex="-1"
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        )}
      </div>
    </div>
  );
};

export default ModernTextField;